<template>
  <div class="sign-result-page">
    <img :src="resultImg" />
    <p class="result">
      {{ approvalData.resultText }}
    </p>
    <div class="tips">
      {{ approvalData.resultDesc }}
    </div>
    <cube-button
      class="btn"
      :class="{ fail_btn: approvalStatus === 2 }"
      @click="clickFn"
      >{{ approvalData.btnName }}</cube-button
    >
  </div>
</template>

<script>
import Bus from "@/utils/Bus";
import api from "@/utils/api";
export default {
  data() {
    return {
      userId: "",
      resultImg: "",
      approvalStatus: "",
      approvalData: {},
      approvalStatusDesc: {
        0: {
          resultText: '您的签署申请已提交审核， 请耐心等待~',
          resultDesc: '审核结果将在3个工作日内完成，请关注短信通知',
          btnName: '返回'
        },
        1: {
          resultText: '您的签署申请已通过~',
          resultDesc: '',
          btnName: '返回'
        },
        2: {
          resultText: '您的签署申请审核未通过!',
          resultDesc: '失败原因：',
          btnName: '重新签署'
        }
      }
    };
  },
  watch: {
    // 监听审核状态
    approvalStatus: {
      handler(val) {
        if (val === 2) {
          this.resultImg = require("@/assets/image/bs-2.0/fail.png");
        } else {
          this.resultImg = require("@/assets/image/bs-2.0/success.png");
        }
      },
      immediate: true
    }
  },
  created() {
    Bus.$emit("hide-loading");
    const { userId, submitResult } = this.$route.query;
    this.userId = userId;
    this.submitResult = submitResult;
    this.queryAgreement();
  },
  mounted() {
    if (this.submitResult) {
      // 保存录屏
      if (clairvoyanceRecord) {
        clairvoyanceRecord.save();
        clairvoyanceRecord.finish({
          notStopRecord: true,
          policyId: this.userId
        });
      }
    }
  },
  methods: {
    // 查询用户协议
    queryAgreement() {
      api.getWebuserAgreementByUserId(this.userId).then(res => {
        const data = res.data;
        if (data.returnCode === "0000" && data.content) {
          const { approvalStatus, approvalStatusTwo, refuseReason } = data.content;
          if(this.$route.query.fileName === '保思品控告知书') {
            this.approvalStatus = approvalStatusTwo;
          } else {
            // 0-待审核 1-审核通过 2-审核不通过
            this.approvalStatus = approvalStatus;
          }
          console.log(this.approvalStatus, this.approvalStatusDesc[this.approvalStatus])
          this.approvalData = this.approvalStatusDesc[this.approvalStatus]
          if(this.approvalStatus === 2) {
            this.approvalData.resultDesc = this.approvalData.resultDesc + refuseReason
          }
        }
      });
    },
    // 按钮点击
    clickFn() {
      if (this.approvalStatus !== 2) {
        // let url =
        //   "http://wx.run4wd.com/authority/wxstore/index?param=MVLNuKLeew3P58WQdOKfF1v8Ji7Ynp2I201ZPa1141r2i79mZOvEkry7DbgSdS-lU4dSSO9Ngndzb4z_-6e5LhLek4bsTNWuoe06q6UYG80=";

        // if (/localhost/.test(location.href)) {
        //   url =
        //     "http://wx.run4wd.com/authority/wxstore/index?param=MVLNuKLeew3P58WQdOKfF1v8Ji7Ynp2I201ZPa1141r2i79mZOvEkry7DbgSdS-lU4dSSO9Ngndzb4z_-6e5LhLek4bsTNWuoe06q6UYG80=";
        // } else if (
        //   /ssish/.test(location.href) ||
        //   /yutai365/.test(location.href)
        // ) {
        //   url =
        //     "http://wx.ssish.com/authority/wxstore/index?param=h9EWoSZVPTOwhoz1hP0UvK_BjMddzZkVXwhjGPoRb9Ghcg0OQSMhr3vCJUgffmaEoiULwr4CnE-yjxnS6KQ7bpc9UzeJXRLdy91kRaiiRM4=";
        // }
        window.history.back();
      } else {
        const cporpa = this.$route.query.cporp
        const name = cporpa === "1" ? "agreementNotices" : "agreementSign";
        this.$router.replace({
          name,
          query: {
            ...this.$route.query,
            userId: this.userId,
            type: "resign"
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sign-result-page {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #333333;
  line-height: 20px;
  text-align: center;
  padding: 0 20px;
  img {
    width: 97px;
    height: 97px;
    margin: 66px auto 9px;
  }
  .result {
    width: 168px;
    margin: auto;
    margin-bottom: 6px;
  }
  .tips {
    font-size: 12px;
    color: #cccccc;
    line-height: 17px;
  }
  .btn {
    position: absolute;
    bottom: 34px;
    left: 50%;
    transform: translateX(-50%);
    width: 331px;
    height: 45px;
    background: #eaeaea;
    border-radius: 7px;
    font-size: 15px;
    font-weight: bold;
    color: #666666;
    &.fail_btn {
      color: #ffffff;
      background: linear-gradient(45deg, #ff7c6c 0%, #ffa297 100%);
    }
  }
}
</style>
